import React from 'react';

const PresentionChartIcon: React.FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path opacity="0.4" d="M21 2V14.1C21 16 20 17 18.1 17H5.89999C3.99999 17 3 16 3 14.1V2H21Z" fill="white" />
    <path
      d="M22 2.75H2C1.59 2.75 1.25 2.41 1.25 2C1.25 1.59 1.59 1.25 2 1.25H22C22.41 1.25 22.75 1.59 22.75 2C22.75 2.41 22.41 2.75 22 2.75Z"
      fill="white"
    />
    <path
      d="M16.6683 22.34C16.5383 22.6 16.2683 22.75 15.9983 22.75C15.8883 22.75 15.7683 22.72 15.6683 22.67L11.9983 20.84L8.3283 22.67C8.2283 22.72 8.10831 22.75 7.99831 22.75C7.72831 22.75 7.4583 22.6 7.3283 22.34C7.1383 21.96 7.28833 21.51 7.66833 21.33L11.2483 19.54V17H12.7483V19.54L16.3283 21.33C16.7083 21.51 16.8583 21.96 16.6683 22.34Z"
      fill="white"
    />
    <path
      d="M7.5009 11.7499C7.2909 11.7499 7.07092 11.6599 6.92092 11.4799C6.65092 11.1599 6.70089 10.6899 7.02089 10.4199L10.1709 7.78993C10.4609 7.54993 10.8309 7.44994 11.1809 7.50994C11.5409 7.56994 11.8509 7.78991 12.0409 8.10991L13.0909 9.85991L16.0209 7.41994C16.3409 7.14994 16.8109 7.19992 17.0809 7.51992C17.3509 7.83992 17.3009 8.30991 16.9809 8.57991L13.8309 11.2099C13.5409 11.4499 13.1709 11.5499 12.8209 11.4899C12.4609 11.4299 12.1509 11.2099 11.9609 10.8899L10.9109 9.13994L7.98091 11.5799C7.84091 11.6899 7.6709 11.7499 7.5009 11.7499Z"
      fill="white"
    />
  </svg>
);

export default PresentionChartIcon;
